import { FunctionComponent, useState } from "react";
import { AccessControlGroup, AccessGroupUserGroupRelation, UserAccessInfo } from '../../types/accessControl';
import { Button, IconButton, Divider } from '../../tailwindcomponents';
import { Typography, Paper, Input, Tooltip, Dialog, Table, TableCell, TableRow } from './../../tailwindcomponents';
import { Edit, Delete } from '../../components/icons';
import AccessControlApi from '../../api/accessControl';
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import ProfileImg from "../../components/Images/ProfileImg";

type GroupComponentProps = {
    setLoading: Function,
    group: AccessControlGroup,
    updateGroupDetails: Function,
    setSelectedGroupId: Function,
    selectedGroupId: number | undefined,
    refresh: Function,
    tabValue: number,
    groupsRelation: AccessGroupUserGroupRelation[],
}

const Group: FunctionComponent<GroupComponentProps> = ({ groupsRelation, tabValue, refresh, group, updateGroupDetails, setSelectedGroupId, selectedGroupId, setLoading }) => {
    const [editDialog, setEditDialog] = useState<boolean>(false);
    const [groupName, setGroupName] = useState<string>("");
    const [groupPermission, setGroupPermission] = useState<string>("");
    const [isUserGroupModal, setIsUserGroupModal] = useState<boolean>(false);
    const [permissions, setPermissions] = useState<UserAccessInfo[]>([]);
    const [selectedUserGroup, setSelectedUserGroup] = useState<string>("");
    const [areYouSureDialogOpen, setAreYouSureDialogOpen] = useState(false);
    const [accesGroupRemovePermissionReason, setAccesGroupRemovePermissionReason] = useState("");
    const [selectedUserAccessGroupPermission, setSelectedUserGroupAccessGroupPermission] = useState<AccessGroupUserGroupRelation | null>();
    const store = useSelector((state: RootState) => state);
    const users = store.employees.all_employees.filter(s => s.visible === true);
    const isDeveloper = store.user.me.user_clearence_groups.includes("Developers");
    const admin = store.user.me.user_clearence_groups.includes("Access Control Admin");

    const onEditGroup = () => {
        const tempName = groupName === "" ? group.group_name : groupName;
        const tempPermission = groupPermission === "" ? group.group_permission_text : groupPermission;
        if (tabValue === 0) {
            setLoading(true);
            AccessControlApi.EditAccessGroup(group.id, tempName, tempPermission).then(res => {
                refresh();
                setEditDialog(false);
                setLoading(false);
            });
        }
        else if (tabValue === 1) {
            setLoading(true)
            AccessControlApi.EditUserGroup(group.id, tempName, tempPermission).then(res => {
                refresh();
                setEditDialog(false);
                setLoading(false);
            });
        }
    }

    const onUserGroupClicked = (e: any, id: number, groupName: string) => {
        e.stopPropagation();
        AccessControlApi.GetAllUsersByGroupId(id, false).then(res => {
            const users = res.data.filter(user => user.inGroup === true);
            setPermissions(users);
            setSelectedUserGroup(groupName);
            setIsUserGroupModal(true);
        });
    }

    const generateTableBody = (row: UserAccessInfo, index: number) => {
        return (
            <TableRow>
                <TableCell >
                    <div className="flex flex-wrap">
                        <ProfileImg imgKey={index} userName={users.find(s => s.Id === row.employee_id)?.userName?.split('@')[0]} />
                    </div>
                </TableCell>
                <TableCell> {row.name} </TableCell>
                <TableCell> {row.job_title} </TableCell>
                <TableCell> {row.starts_at} </TableCell>
                <TableCell> {`${tabValue === 0 ? row.expiration_date : "No exp date for user groups"}`} </TableCell>
            </TableRow>
        )
    }
    const onRemoveUserAccessGroupPermission = (status: boolean) => {
        if (status) {
            AccessControlApi.RemoveUserGroupFromAccessGroup(selectedUserAccessGroupPermission!.user_groups_access_permissions_id, accesGroupRemovePermissionReason).then(res => {
                setAreYouSureDialogOpen(false);
                setAccesGroupRemovePermissionReason("");
                setSelectedUserGroupAccessGroupPermission(null);
                refresh();
            })
        }
    }
    const onDeleteGroup = () => {
        AccessControlApi.DeleteUserGroup(group.id).then(res => {
            refresh();
            setEditDialog(false);
            setLoading(false);
        })
    }
    const hasGroupsRelations = groupsRelation.filter(s => s.user_group_id === group.id).length > 0;
    const isSelected = selectedGroupId !== undefined && selectedGroupId === group.id;
    return (
        <div className="cursor-pointer p-1">
            <div onClick={() => { setSelectedGroupId(group.id); updateGroupDetails(group) }}>
                <Paper elevation={9} className={`transition-colors hover:bg-content/[0.04] ${isSelected ? 'ring-2 ring-primary ring-inset' : ''}`}>
                    <div className="flex flex-col justify-between w-full p-2">
                        <div className="flex flex-row flex-wrap justify-between">
                            <div >
                                <Typography customFontSize={14} cursor="pointer" variant="h6" fontWeight="normal" margin={[1, 0, 0, 1]} text={group.group_name} />
                                {(selectedGroupId !== undefined && selectedGroupId === group.id) &&
                                    <Typography cursor="pointer" margin={[1, 0, 0, 1]} text={group.group_permission_text} />
                                }
                            </div>
                            {(( tabValue === 1 && admin) || (isDeveloper)) &&
                                <div>
                                    <IconButton onClick={(e: any) => { setEditDialog(true); setGroupName(group.group_name); setGroupPermission(group.group_permission_text); e.stopPropagation(); }} id="drawerButton">
                                        <Edit className="cursor-pointer h-5" onClick={() => setEditDialog(true)} />
                                    </IconButton>
                                </div>
                            }
                        </div>
                        <div>
                            {tabValue === 0 &&
                                <div>
                                    {(selectedGroupId !== undefined && selectedGroupId === group.id) &&
                                        <div>
                                            <Divider className="hidden lg:block mt-4" orientation="horizontal" variant="middle" flexItem />
                                            {
                                                (groupsRelation !== undefined && groupsRelation.length > 0) &&
                                                <div>
                                                    <Typography cursor="pointer" margin={[1, 0, 0, 1]} text={` `} />
                                                    {groupsRelation.map(el => {
                                                        if (el.access_group_id === group.id) {
                                                            return (
                                                                <div>
                                                                    <Tooltip type="primary" title={`${el.user_group_permission_text}`} placement="top-start">
                                                                        <span className="flex justify-between items-center gap-2 w-full">
                                                                            <Button variant="text" onClick={(e: any) => onUserGroupClicked(e, el.user_group_id, el.user_group_name)} className="flex-1 min-w-0 justify-start text-left">
                                                                                <span className="truncate">{el.user_group_name}</span>
                                                                            </Button>
                                                                            <IconButton onClick={() => { setAreYouSureDialogOpen(true); setSelectedUserGroupAccessGroupPermission(el); }}>
                                                                                <Delete color="error" />
                                                                            </IconButton>
                                                                        </span>
                                                                    </Tooltip>
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            {tabValue === 1 &&
                                <div>
                                    {(selectedGroupId !== undefined && selectedGroupId === group.id) &&
                                        <div>
                                            <Divider className="hidden lg:block mt-4" orientation="horizontal" variant="middle" flexItem />
                                            {
                                                (groupsRelation !== undefined && groupsRelation.length > 0) &&
                                                <div>
                                                    <Typography customFontSize={18} cursor="pointer" margin={[1, 0, 0, 1]} text={'Parent groups:'} />
                                                    {groupsRelation.map(el => {
                                                        if (el.user_group_id === group.id) {
                                                            return (
                                                                <div>
                                                                    <Tooltip title={`${el.access_group_permission_text}`} type='primary' placement="top-start">
                                                                        <Typography cursor="pointer" margin={[1, 0, 0, 1]} text={el.access_group_name} />
                                                                    </Tooltip>
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </Paper>
            </div>
            <Dialog
                visible={editDialog}
                max_width={"sm"}
                title={"Edit group"}
                context={
                    <div className="flex flex-row flex-wrap content-center">
                        <div className="w-1/2">
                            <Input
                                multiline={false}
                                label_text="Group name"
                                help_text="Please type in a new name for the group"
                                type="text"
                                value={groupName}
                                width={80}
                                onTextChange={(value: string) => setGroupName(value)}
                            />
                        </div>
                        <div className="w-1/2">
                            <Input
                                multiline={true}
                                label_text="Group permission"
                                help_text="Please type in new permisson text for the group"
                                type="text"
                                value={groupPermission}
                                width={80}
                                onTextChange={(value: string) => setGroupPermission(value)}
                            />
                        </div>
                        <div className="flex flex-wrap w-full justify-around">
                            <Button variant="contained" color='primary' className="mb-8" onClick={() => onEditGroup()}>Submit</Button>
                            {tabValue === 1 &&
                                <Tooltip title={hasGroupsRelations ? "Please remove all access before deleting" : ""} type='primary' placement="top-start">
                                    <Button disabled={hasGroupsRelations} variant="contained" color='error' className="mb-8" onClick={() => onDeleteGroup()}>Delete</Button>
                                </Tooltip>
                            }
                        </div>
                    </div>
                }
                onClose={(status: any) => setEditDialog(false)}
                strict={false}
                show_options={false}
            />
            <Dialog
                visible={isUserGroupModal}
                max_width={"md"}
                title={`Employees in user group: ${selectedUserGroup}`}
                context={
                    <Table
                        headers={["IMAGE", "FULL NAME", "JOB TITLE", "STARTS AT", "EXPIRES AT"]}
                        rows={permissions}
                        generateBody={(row: any, index: number) => generateTableBody(row, index)}
                        pagination={true}
                        defaultRowsPerPage={10}
                        skipIndexCol={true}
                    />
                }
                onClose={(status: any) => setIsUserGroupModal(status)}
                strict={false}
                show_options={false}
            />
            <Dialog
                visible={areYouSureDialogOpen}
                max_width={"md"}
                title={`Are you sure you want to remove  ${selectedUserAccessGroupPermission?.user_group_name}  from ${selectedUserAccessGroupPermission?.access_group_name}`}
                context={
                    <div>
                        <Input
                            multiline={false}
                            label_text="Reason"
                            help_text="Please provide a reason why you are removing permission"
                            type="text"
                            value={accesGroupRemovePermissionReason}
                            width={100}
                            onTextChange={(value: string) => setAccesGroupRemovePermissionReason(value)}
                        />
                    </div>
                }
                onClose={(status: boolean) =>
                    status
                        ? onRemoveUserAccessGroupPermission(status)
                        : (setAreYouSureDialogOpen(false), setSelectedUserGroupAccessGroupPermission(null))
                }
                strict={false}
                show_options={true}
            />
        </div >
    )
}
export default Group;